<template>
    <div class="tradesman-information">
        <Row>
            <Col :xs="24" :sm="24">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                    <Select v-model="formItem.uuid" clearable filterable placeholder="选择匠人">
                        <Option v-for="item in trandList" :value="item.uuid" :key="item.uuid">{{item.nickname}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <Input v-model="formItem.key" clearable placeholder="输入名称查找..."></Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="renderTable(1)">查找</Button>
                </FormItem>
                <FormItem>
                    <Button @click="showModel()" type="success" class="f-l">添加</Button>
                </FormItem>
            </Form>
            </Col>
        </Row>
        <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;">
                <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator
                      show-total @on-change="changePage()"></Page>
            </div>
        </div>
        <!-- 添加的弹出 -->
        <Modal v-model="showModalStatus" :title="title" @on-ok="createInfo('dataInfoValidate')" :loading="loading">
            <Form :model="dataInfo" ref="dataInfoValidate" :rules="dataInfoValidate" action="javascript:void(0)">
                <FormItem label="选择匠人" label-position="top" prop="uuid">
                    <Select v-model="dataInfo.uuid" clearable filterable placeholder="选择匠人">
                        <Option v-for="item in trandList" :value="item.uuid" :key="item.uuid">{{item.nickname}}
                        </Option>
                    </Select>
                </FormItem>
                <FormItem label="名称" prop="title">
                    <Input v-model="dataInfo.title" placeholder="输入名称..."></Input>
                </FormItem>
                <FormItem label="跳转地址" prop="link_url">
                    <Input v-model="dataInfo.link_url" placeholder="输入跳转地址..."></Input>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
    export default {
        name: "tradesman-information",
        data() {
            return {
                loading: true,
                dataloading: true,
                thumblist: [],
                pages: {
                    page: 1,
                    size: 10,
                    total: 0
                },
                title: '',
                formItem: {
                    'key': '',
                    uuid:'',
                },
                bigDisplay: '',
                list: [
                    {
                        title: 'Id',
                        key: 'id',
                        fixed: 'left',
                        width: 90
                    },
                    {
                        title: '名称',
                        key: 'title',
                        minWidth: 200
                    },
                    {
                        title: '匠人名称',
                        width: 200,
                        render: (h, params) => {
                            return h("div", [h("span", {}, params.row.tradesman.nickname)]);
                        }
                    },
                    {
                        title: '跳转地址',
                        key: 'link_url',
                        width: 200
                    },
                    {
                        title: '状态',
                        key: 'status',
                        width: 100,
                        render: (h, params) => {
                            return h('div', [
                                h('i-switch', {
                                    props: {
                                        value: params.row.status == 1 ? true : false  //控制开关的打开或关闭状态，官网文档属性是value
                                    },
                                    on: {
                                        'on-change': (value) => {
                                            this.changeStatus(params.row.id, value)
                                        }
                                    }
                                }, '开关')
                            ]);
                        }
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 150,
                        align: 'left',
                        fixed: 'right',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    style: {
                                        marginRight: '8px'
                                    },
                                    props: {
                                        type: 'primary',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.detail(params.index, params.row.id)
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    style: {
                                        marginRight: '8px'
                                    },
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            this.remove(params.index, params.row.id)
                                        }
                                    }
                                }, '删除')
                            ]);
                        }
                    }
                ],
                trandList: [],
                tablelist: [],
                dataInfo: {
                    title: '',
                    link_url: true,
                },
                showModalStatus: false,
                dataInfoValidate: {
                    title: [
                        {required: true, message: '名称必须填写', trigger: 'blur'}
                    ],
                },
            }
        },
        created: function () {
            this.$api.tradesman.list({page: 1, size: 10000, register_status: -1}).then(res => {
                if (res.code == 200) {
                    this.trandList = res.result.list;
                }
            });
            // 取数据
            this.getTableList();
        },
        components: {},
        methods: {
            getTableList: function () {
                this.$api.tradesmanInformation.list({"page": this.pages.page, "size": this.pages.size}).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            },
            // 展开添加
            showModel() {
                this.title = "添加分类";
                this.dataInfo = {
                    name: '',
                    status: 1
                };
                this.$refs['dataInfoValidate'].resetFields();
                this.showModalStatus = !this.showModalStatus;
            },
            // 添加
            createInfo(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        if (this.dataInfo.id == null || this.dataInfo.id == 0) {
                            this.$api.tradesmanInformation.create(this.dataInfo).then(res => {
                                if (res.code == 200) {
                                    this.getTableList();
                                }
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.showModalStatus = !this.showModalStatus;
                            });
                        } else {
                            this.$api.tradesmanInformation.edit(this.dataInfo).then(res => {
                                if (res.code == 200) {
                                    this.getTableList();
                                }
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.showModalStatus = !this.showModalStatus;
                            });
                        }
                    } else {
                        this.$Message.error('请检查输入的信息是否正确！');
                        this.loading = false
                        this.$nextTick(() => {
                            this.loading = true;
                        });
                    }
                })
            },
            // 删除
            remove: function (index, id) {
                // 弹出确认框
                this.$Modal.confirm({
                    title: '警告',
                    content: '<p>此操作不可恢复，三思而后行...</p>',
                    onOk: () => {
                        this.$api.tradesmanInformation.remove({id: id}).then(res => {
                            if (res.code == 200) {
                                this.$Message.success(res.msg);
                                // this.tablelist.splice(index, 1);
                                this.getTableList();
                            }
                        });
                    }
                });
            },
            // 详情
            detail(index, id) {
                this.title = "编辑分类";
                this.intangibleCate = {
                    name: '',
                    status: 1
                };
                this.$refs['dataInfoValidate'].resetFields();
                this.showModalStatus = !this.showModalStatus;
                this.$api.tradesmanInformation.detail({id: id}).then(res => {
                    this.dataInfo = res.result;
                });
            },
            // 修改状态
            changeStatus: function (index, value) {
                this.$api.tradesmanInformation.status({id: index, status: value}).then(res => {
                    if (res.code == 200) {
                        this.$Message.success(res.msg);
                    }
                });
            },
            // 翻页
            changePage() {
                this.pages.page = this.$refs['listPage'].currentPage;
                this.renderTable(1);
            },
            // 筛选
            renderTable: function (name) {
                if (name != 1) {
                    this.pages.page = 1;
                }
                this.dataloading = true;
                var ps = {'key': this.formItem.key, "page": this.pages.page, "size": this.pages.size,uuid:this.formItem.uuid};
                this.$api.tradesmanInformation.list(ps).then(res => {
                    this.dataloading = false;
                    if (res.code == 200) {
                        this.tablelist = res.result.list;
                        this.pages.total = res.result.total;
                        this.$Message.success(res.msg);
                    }
                });
                return;
            }
        },
    }
</script>

<style scoped>

</style>